import React from "react";
import { fade, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import HomeIcon from '@material-ui/icons/Home';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import GrainIcon from '@material-ui/icons/Grain';
import { Typography, Hidden } from "@material-ui/core";
import { Link, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux';
const useStyles = makeStyles((theme) => ({

  linkTitle: {
    color: "white",
    marginLeft: "5px",
    fontWeight: 400,
    fontSize: 14,
    marginRight: 20,
  },
  NavbarRegister: {
    backgroundColor: theme.blueColor,
    boxShadow: "none",
    paddingLeft: 0,
    paddingRight: 0,
  },
  headerInner: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: 15,
    paddingBottom: 15,
  },
  link: {
    display: 'flex',
    color: "white"
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
}));

export default function AuthNavbar(props) {
  const classes = useStyles();
  let history = useHistory()
  // console.log(history.location.pathname, "this is the =====>")
  const Aut = useSelector(state => state.AutReducer)

  return (
    <AppBar className={classes.NavbarRegister}>
      <Container maxWidth="md">
        <div className={classes.headerInner}>
          <div style={{ marginLeft: "4rem", paddingTop: ".3rem" }}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link to="/" className={classes.link}>
                <HomeIcon className={classes.icon} />
                 Home
                 </Link>

              <Typography color="textPrimary" className={classes.link}>
                <Link to="/dashboard" className={classes.link}>
                  <GrainIcon className={classes.icon} />
              Dashboard
              </Link >
              </Typography>
            </Breadcrumbs>
            {/* <Typography variant="h6" ><Link to={``} style={{ color: "white" }}>Home</Link>/Dashboard </Typography> */}
          </div>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {Aut.loinAddress.user && <div style={{ display: "flex", alignItems: "center" }}>
              <Button color="inherit" className={classes.linkTitle}>
                {Aut.loinAddress.user && Aut.loinAddress.user.name}
              </Button>
              <Hidden mdDown>  <Typography>{Aut.loinAddress.user && Aut.loinAddress.user.walletAddress.slice(0, 5) + "..." + Aut.loinAddress.user.walletAddress.slice(40, 48)}</Typography></Hidden>
            </div>}
          </div>
        </div>
      </Container>
    </AppBar>
  );
}
